import { render, staticRenderFns } from "./par.vue?vue&type=template&id=48e2766c&"
import script from "./par.vue?vue&type=script&lang=js&"
export * from "./par.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports